__turbopack_context__.v({
  "body": "CDescriptivePage-module__m0OOVq__body",
  "empty": "CDescriptivePage-module__m0OOVq__empty",
  "paragraph": "CDescriptivePage-module__m0OOVq__paragraph",
  "paragraphText": "CDescriptivePage-module__m0OOVq__paragraphText",
  "paragraphUnsupported": "CDescriptivePage-module__m0OOVq__paragraphUnsupported",
});
